<template>
  <div class="flex flex-wrap -mx-5 py-10">
    <div v-if="userProfile.id === profile.id" class="w-full flex justify-end mb-5 px-5">
      <d-btn href="/profile/update">
        Edit Profile
      </d-btn>
    </div>
    <div class="w-full md:w-1/3 px-5">
      <div class="flex justify-center -mb-10">
        <d-avatar :img-src="userProfile.profileImageUrl" :text="userProfile.fullName" size="100" />
      </div>
      <div class="bg-primary-300 rounded rounded-b-none pt-16 px-5 pb-5 text-center">
        <p class="text-2xl">
          {{ userProfile.fullName }}
        </p>
        <p>{{ userProfile.preferredEmail }}</p>
      </div>
      <div class="bg-white shadow rounded rounded-t-none p-5">
        <div v-if="userProfile.bio">
          <p class="font-bold">
            About Me
          </p>
          <div class="wysiwyg-editor-container" v-html="userProfile.bio" />
        </div>
        <div v-if="userProfile.schools" class="pt-5">
          <p class="font-bold">
            Teaching Location
          </p>
          <div class="wysiwyg-editor-container" v-html="userProfile.schools" />
        </div>
        <div class="pt-5" v-if="user.schoolEmail">
          <p class="font-bold">
            School Email
          </p>
          <p>
            {{ user.schoolEmail }}
          </p>
        </div>
        <div class="pt-5"  v-if="user.personalEmail">
          <p class="font-bold">
            Personal Email
          </p>
          <p>
            {{ user.personalEmail }}
          </p>
        </div>
      </div>
    </div>
    <div class="w-full md:w-2/3 px-5">
      <div class="bg-white shadow rounded rounded-t-none p-5">
        <h3 class="text-2xl">
          Your Demographics
        </h3>
        <div class="pt-5"  v-if="user.schoolPhone">
          <p class="font-bold">
            School Phone
          </p>
          <p >
            {{ user.schoolPhone }}
          </p>
        </div>
        <div class="pt-5" v-if="user.altPhone">
          <p class="font-bold">
            Personal Phone
          </p>
          <p >
            {{ user.altPhone }}
          </p>
        </div>
        <div class="pt-5" v-if="mentorFieldSet.position">
          <p class="font-bold">
            Current Position
          </p>
          <p >
            {{ mentorFieldSet.position }}
          </p>
        </div>
        <br>
        <div>
          <p class="font-bold" style="float: left">
            Wrong Information?
          </p>
          <br>
          <p class="md:w-2/3">
            Use the submit feedback option under the account
            drop-down in the upper-right corner of the page to request changes.
          </p>
        </div>
      </div>
      <div class="bg-white shadow py-3 px-10 mt-10 rounded">
        <h3>{{ isCurrentUser ? 'My' : `${userProfile.fullName}'s` }} Resources</h3>
        <div v-if="resources.length > 0 && !loadingResources" class="flex flex-wrap items-stretch -mx-3 mt-5">
          <div v-for="item in resources" :key="item.id" class="w-full mb-6 md:w-1/2 px-3">
            <resource-card :resource="item" :is-admin="hasRole('System Administrator')" :current-user-id="profile.id" @update="getResourcesCurrentUserCanSee" />
          </div>
        </div>
        <div v-else-if="loadingResources" key="loading" class="flex justify-center py-10">
          <d-loader />
        </div>
        <div v-else key="empty" class="text-center py-10">
          <p>There are no resources available to show at this time.</p>
        </div>
        <div class="flex justify-end">
          <d-pagination :total="total" :per-page="pagination.pageSize" :current="pagination.page" @change="page => pagination.page = page" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DPagination from '@devsquared/d2kit/src/js/elements/DPagination/DPagination.vue';
  import axios from 'axios';

  export default {
    parent: true,
    components: {
      DPagination,
    },

    props: {
      userProfile: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        mentorFieldSet: { },
        user: { },
        loadingResources: true,
        resources: [],
        total: 0,
        pagination: {
          page: 1,
          pageSize: 10,
          sortField: 'name',
          sortOrder: 'asc',
        },
      };
    },

    computed: {
      ...mapGetters('d2Auth', ['profile', 'hasRole']),

      isCurrentUser() {
        return this.profile.id === this.userProfile.id;
      },
    },

    watch: {
      pagination: {
        handler() {
          this.getResourcesCurrentUserCanSee();
        },
        deep: true,
      },
    },

    mounted() {
      this.getResourcesCurrentUserCanSee();
      this.getUserDemographics();
      this.getUserMentorFieldSet();
    },

    methods: {
      async getResourcesCurrentUserCanSee() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingResources = true;
        const { data } = await axios.get(`/api/resources/${this.userProfile.id}/paged?${params}`);
        this.resources = data.resultItems;
        this.total = data.totalRecords;
        this.loadingResources = false;
      },

      async getUserDemographics() {
        if (this.userProfile.id === this.profile.id) {
          const { data } = await axios.get('/api/profile');
          this.user = data;
        } else {
          const { data } = await axios.get(`/api/admin/users/${this.userProfile.id}`);
          this.user = data;
        }
      },

      async getUserMentorFieldSet() {
        if (this.userProfile.mentorFieldSetId !== null) {
          const { data } = await axios.get(`/api/mentor-field-sets/user/${this.userProfile.id}`);
          this.mentorFieldSet = data;
        }
      },
    },
  };
</script>